import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ButtonPadraoComponent} from '../../../../shared/components/button-padrao/button-padrao.component';
import {NgIf} from '@angular/common';
import {MatTooltip} from '@angular/material/tooltip';
import {CelularMaskPipe} from '../../../../shared/pipe/celular-mask.pipe';
import {ProgressBarDataComponent} from '../../../../shared/components/progress-bar-data/progress-bar-data.component';
import {Sessao} from '../../../../shared/model/sessao/sessao.model';

@Component({
  selector: 'app-card-sessao-linha-superior',
  standalone: true,
  imports: [
    ButtonPadraoComponent,
    NgIf,
    MatTooltip,
    CelularMaskPipe,
    ProgressBarDataComponent
  ],
  templateUrl: './card-sessao-linha-superior.component.html',
  styleUrl: './card-sessao-linha-superior.component.css'
})
export class CardSessaoLinhaSuperiorComponent {

  @Input() nomeContato?: string;
  @Input() numeroContato?: string;
  @Input() isAtivo?: boolean;
  @Input() isExibicao = false;
  @Input() sessao?: Sessao;

  @Output() exibirDetalhes = new EventEmitter<boolean>();
  @Output() modalChat = new EventEmitter<boolean>();
  @Output() editarDetalhes = new EventEmitter<boolean>();
  @Output() reiniciarSessao = new EventEmitter<boolean>();


  abrirModalDetalhes(){
    this.exibirDetalhes.emit(true);
  }
  abrirModalChat(){
    this.modalChat.emit(true);
  }
  abrirModalEdicaoDetalhes(){
    this.editarDetalhes.emit(true);
  }
  abrirModalReiniciarSessao(){
    this.reiniciarSessao.emit(true);
  }

}
